import { render } from "./SearchBar.vue?vue&type=template&id=18674c0c"
import script from "./SearchBar.vue?vue&type=script&lang=js"
export * from "./SearchBar.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/HistoricalData/UpgradeRecords/components/SearchBar.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "18674c0c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('18674c0c', __exports__)) {
    api.reload('18674c0c', __exports__)
  }
  
  module.hot.accept("./SearchBar.vue?vue&type=template&id=18674c0c", () => {
    api.rerender('18674c0c', render)
  })

}


export default __exports__